/* Blank PDP colour row (snippets/blanks-color-find.liquid). Keeps "Color: <name>" in step with
   the theme's colour radios, and on styles with more than 10 colours drives the quick-find
   dropdown: picking a row clicks that colour's radio, so the variant, price, image and URL update
   through the theme's normal change flow (the picker is not re-rendered on change, so the radios
   stay put). Clicking a swatch updates the row in turn.

   Chip colours are read off the painted swatches. blanks-swatch-colors.js paints those and loads
   after this script, so the chips are read on open and on every change rather than once.
   (Justin 2026-09-23) */
(function () {
  var root = document.querySelector('[data-bcf]');
  if (!root) return;
  var nameEl = root.querySelector('[data-bcf-name]');
  var trigger = root.querySelector('.bqb__ctrigger');
  var list = root.querySelector('.bqb__clist');
  var section = root.closest('[id^="shopify-section-"]') || document;

  function radios() {
    var item = section.querySelector('.product-variant__item--color');
    var blk = item && item.closest('.product-variant');
    return blk ? blk.querySelectorAll('.product-variant__item--color input[type="radio"]') : [];
  }
  function radioFor(name) {
    var r = radios();
    for (var i = 0; i < r.length; i++) if (r[i].value === name) return r[i];
    return null;
  }
  function colorOf(name) {
    var r = radioFor(name);
    var sw = r && r.parentNode.querySelector('.product-variant__item-swatch');
    if (!sw) return '';
    var bg = sw.style.backgroundColor || getComputedStyle(sw).backgroundColor;
    return bg && bg !== 'transparent' && bg !== 'rgba(0, 0, 0, 0)' ? bg : '';
  }

  function sync() {
    var cur = null, r = radios();
    for (var i = 0; i < r.length; i++) if (r[i].checked) { cur = r[i].value; break; }
    if (cur === null) return;
    if (nameEl) nameEl.textContent = cur;
    var chip = root.querySelector('.bqb__cchip');
    if (chip) {
      var c = colorOf(cur);
      chip.style.backgroundColor = c;
      chip.classList.toggle('bqb__cchip--unknown', !c);
    }
    if (!list) return;
    var rows = list.querySelectorAll('[data-bcf-color]');
    for (var j = 0; j < rows.length; j++) {
      rows[j].classList.toggle('is-on', rows[j].getAttribute('data-bcf-color') === cur);
    }
  }

  section.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.product-variant__item--color')) sync();
  });

  /* Hovering a swatch previews its name and chip in the row; moving off the swatches puts the
     chosen colour back (sync reads the checked radio). A tap on a phone selects as before.
     (Justin 2026-09-23) */
  function preview(name) {
    if (nameEl) nameEl.textContent = name;
    var chip = root.querySelector('.bqb__cchip');
    if (!chip) return;
    var c = colorOf(name);
    chip.style.backgroundColor = c;
    chip.classList.toggle('bqb__cchip--unknown', !c);
  }
  function swatchOf(el) { return el && el.closest ? el.closest('.product-variant__item--color') : null; }
  section.addEventListener('mouseover', function (e) {
    var it = swatchOf(e.target), r = it && it.querySelector('input[type="radio"]');
    if (r) preview(r.value);
  });
  section.addEventListener('mouseout', function (e) {
    if (swatchOf(e.target) && !swatchOf(e.relatedTarget)) sync();
  });
  sync();
  window.addEventListener('load', sync);

  if (!trigger || !list) return;

  function paintRows() {
    var rows = list.querySelectorAll('[data-bcf-color]');
    for (var i = 0; i < rows.length; i++) {
      var chip = rows[i].querySelector('.bqb__lchip');
      var c = colorOf(rows[i].getAttribute('data-bcf-color'));
      chip.style.backgroundColor = c;
      if (c) chip.removeAttribute('data-unknown'); else chip.setAttribute('data-unknown', '1');
    }
  }
  function toggle(open) {
    var want = typeof open === 'boolean' ? open : list.hasAttribute('hidden');
    if (want) {
      paintRows();
      list.removeAttribute('hidden');
      var on = list.querySelector('.is-on');
      if (on) list.scrollTop = Math.max(0, on.offsetTop - 8);
    } else {
      list.setAttribute('hidden', '');
    }
    trigger.setAttribute('aria-expanded', want ? 'true' : 'false');
  }

  trigger.addEventListener('click', function (e) {
    e.stopPropagation();
    toggle();
  });
  list.addEventListener('click', function (e) {
    var row = e.target.closest('[data-bcf-color]');
    if (!row) return;
    var r = radioFor(row.getAttribute('data-bcf-color'));
    if (r && !r.checked) r.click();
    toggle(false);
    sync();
    trigger.focus();
  });
  document.addEventListener('click', function (e) {
    if (!root.contains(e.target)) toggle(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !list.hasAttribute('hidden')) { toggle(false); trigger.focus(); }
  });
})();
